import { render, staticRenderFns } from "./SolutionNursingDetail.vue?vue&type=template&id=1b98057e&"
import script from "./SolutionNursingDetail.vue?vue&type=script&lang=ts&"
export * from "./SolutionNursingDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports